import axiosInstance from "../interceptors";

// Dashboard V2 analytics API — see DASHBOARD_V2_API_INTEGRATION.md.
// All endpoints live in common-service, exposed through the gateway under the
// /common prefix (StripPrefix=1 → /common/analytics/dashboard → /analytics/dashboard).
//
// Tenant scoping: every call carries ?tenantId=<id>, read from localStorage with
// the same key/fallback the rest of the app uses. The gateway validates it
// against the JWT `tenant` claim, so it must be present and correct.
const DASHBOARD_BASE = "/common/analytics/dashboard";

const getTenantId = () => localStorage.getItem("tenantId") || "1";

// Period maps to the UI toggle: today | 7d | 30d | all (defaults to 30d).
const baseParams = (period = "30d") => ({
  tenantId: getTenantId(),
  period,
});

// §1 Aggregate — one call returns every widget for first paint. Re-call on
// period-toggle change. The response nests each widget under its named key
// (header, actionChips, kpiTiles, …) using the inner array/object shape.
export const getDashboard = (period = "30d", opts = {}) =>
  axiosInstance.get(DASHBOARD_BASE, { ...opts, params: baseParams(period) });

// §12 System health — good candidate for independent ~60s polling.
export const getSystemHealth = (period = "30d", opts = {}) =>
  axiosInstance.get(`${DASHBOARD_BASE}/system-health`, {
    ...opts,
    params: baseParams(period),
  });

// §11 Activity feed — independent refresh/polling; paginated by limit/offset.
export const getActivity = (period = "30d", limit = 8, offset = 0, opts = {}) =>
  axiosInstance.get(`${DASHBOARD_BASE}/activity`, {
    ...opts,
    params: { ...baseParams(period), limit, offset },
  });

// §6a Create hiring goal — POST. Kept for when the "+ Goal" flow is wired up.
// team (required, non-blank), target (required, positive int), deadline (ISO, optional).
export const createHiringGoal = (body, opts = {}) =>
  axiosInstance.post(
    `${DASHBOARD_BASE}/hiring-goals`,
    { tenantId: getTenantId(), ...body },
    opts,
  );
